import common from './common'

function inputRetention(obj) {
    // 価格一律の場合、画面に間隔を詰めるように
    if (obj.siteCodeInfo[0].PRICING_METHOD == 1) {
        obj.styleObject = {
            paddingTop: '0px',
            backgroundImage: 'none',
        }
    }
    //入力保持
    obj.items = common.getStore(obj, 'mediumItems')
    obj.addItem = common.getStore(obj, 'addMediumItem')
    obj.mediumBox.medium_box_cnt = common.getStore(obj, 'medium_box_cnt')

    // 「大型」表示品目を取得
    obj.largeView = common.getStore(obj, 'largeItems').length
    // 「小型」表示品目を取得
    obj.smallView = common.countSmallView(obj)

    let url = common.constant.GET_FEE_URL
    // レスポンス処理
    let func = response => {
        if(response.data.defective_master_data.length > 0){
          console.log(obj.$msg.ERROR.MSG_9990, response.data.defective_master_data)
        }

        obj.salesTaxRate = response.data.sales_tax_rate
        obj.items.forEach(item => {
            parseData(response.data, item)
        })
        // 「その他中型」表示品目がある場合
        if (obj.addItem.code) {
            parseData(response.data, obj.addItem)
        }
    }

    let params = {
        yubin: common.getStore(obj, 'addressFormSelected').YUBIN.replace('-', ''),
        site_code: process.env.VUE_APP_SITE_CODE,
        large_items: [],
        medium_items: [],
        small_items: [],
    }
    // 各中型品目
    obj.items.forEach(item => {
        params.medium_items.push({
            'item': item.code,
        })
    })
    // 「その他中型」表示品目がある場合
    if (obj.addItem.code) {
        params.medium_items.push({
            'item': obj.addItem.code,
        })
    }
    common.executeAxiosPost(url, func, params, obj)
}

function setUnit(obj, num, item) {
    item.unit = num
    item.unitFlg = false
    item.numArray = []
    // 選択した料金の分類と金額をリセット
    if (num === 0) {
        for (let kbn in item.selectedOptions) {
            item.selectedOptions[kbn] = { feeCat: null, required: false }
        }
        setTotalFee(obj, item)
    }
}

function submitMediumItems(obj) {
    //エラーフラグを初期化
    obj.setErrorFlg(false)
    // 選択した品目数
    let count = common.countLargeItems(obj)

    obj.items.forEach(item => {
        //台数入力チェック null→0 マイナス→0
        item.unit = item.unit ?? 0
        item.unit = item.unit < 0 ? 0 : item.unit
        count += item.unit
        // オプション料金の必須チェック
        optionsCheck(obj, item)

        // 法人サイトの場合、回収台数が最大値を超えていないかまたは、小数になっていないかチェック
        if(obj.siteCodeInfo[0].BIZ_FLG == '1' && (item.unit > common.constant.MAXQUANTITY_BIZ || common.isSyousuNum(item.unit))){
            item.bizMaxUnitErrFlg = true
            obj.setErrorFlg(true)
        }else{
            item.bizMaxUnitErrFlg = false
        }
    })
    //「その他中型」表示品目がある場合、addItem台数入力チェック null→0　マイナス→0
    if (obj.addItem.code) {
        obj.addItem.unit = obj.addItem.unit ?? 0
        obj.addItem.unit = obj.addItem.unit < 0 ? 0 : obj.addItem.unit
        count += obj.addItem.unit
        // オプション料金の必須チェック
        optionsCheck(obj, obj.addItem)
        // 法人サイトの場合、回収台数が最大値を超えていないかチェック
        if(obj.siteCodeInfo[0].BIZ_FLG == '1' && (obj.addItem.unit > common.constant.MAXQUANTITY_BIZ || common.isSyousuNum(obj.addItem.unit))){
            obj.addItem.bizMaxUnitErrFlg = true
            obj.setErrorFlg(true)
        }else{
            obj.addItem.bizMaxUnitErrFlg = false
        }
    }

    let path = ''
    if (obj.smallView) {
        path = common.constant.SMALL_ITEMS_PATH
    } else {
        path = common.constant.SPECIFIC_DATETIME_PATH
    }

    if (path === common.constant.SPECIFIC_DATETIME_PATH && count === 0) {
        obj.setErrorFlg(true)
        if (common.getStore(obj, 'largeItems').length) {
            obj.error.no_items = true
        } else {
            obj.error.no_items_without_large = true
        }
    }else{
        obj.error.no_items = false
        obj.error.no_items_without_large = false
    }

    // ストアにセット
    common.setStore(obj, 'errorFlg', obj.errorFlg())
    common.setStore(obj, 'mediumItems', obj.items)
    common.setStore(obj, 'addMediumItem', obj.addItem)

    common.setStore(obj, 'medium_box_cnt', obj.mediumBox.medium_box_cnt)

    common.setRoute(obj, path)
}

function pageBack(obj) {
    let path = common.constant.LARGE_ITEMS_PATH
    if (common.getStore(obj, 'largeItems').length === 0) {
        path = common.constant.ADDRESS_FORM_PATH
    }
    common.pageBack(obj, path)
}

/**
 * レスポンスデータ解析
 * @param {Object} data - レスポンスデータ
 * @param {Array} data.medium_items - 中型料金マスタデータ
 * @param {number} data.sales_tax_rate - 税率
 * @param {Object} item - 中型表示品目
 */
function parseData(data, item) {
    // 料金区分が「回収料金」のデータを取得
    const itemFinded = data.medium_items.find(mediumItem => mediumItem.ITEM === item.code && mediumItem.FEE_KBN === common.constant.SMALL_APPLIANCES)

    let options = []
    // 料金区分が「回収料金」以外のデータをオプション料金として収集
    const target = data.medium_items.filter(mediumItem => mediumItem.ITEM === item.code && mediumItem.FEE_KBN !== common.constant.SMALL_APPLIANCES)
    if (target.length > 0) {
        // オプション料金整形
        const map = new Map()
        options = target.reduce((result, cur) => {
            if (map.has(cur.FEE_KBN)) {
                result[result.length - 1]['fee_cat'].push({ code: cur.FEE_CATEGORY, name: cur.FEE_CAT_NM, fee: cur.FEE })
            } else {
                map.set(cur.FEE_KBN, cur.FEE_KBN_NM)
                result.push({ fee_kbn: { code: cur.FEE_KBN, name: cur.FEE_KBN_NM }, fee_cat: [{ code: cur.FEE_CATEGORY, name: cur.FEE_CAT_NM, fee: cur.FEE }] })
            }
            return result
        }, [])
    }

    item.fee = itemFinded.FEE
    item.fee_inc_tax = common.includingTax(itemFinded.FEE, data.sales_tax_rate)
    item.options = options

    // 最初にページを開く場合
    if (item.selectedOptions === null) {
        item.selectedOptions = item.options.reduce((acc, cur) => {
            acc[cur.fee_kbn.code] = { feeCat: null, required: false }
            return acc
        }, {})
        item.totalFee = item.fee
        item.totalFeeIncTax = item.fee_inc_tax
    }
}

/**
 * オプション料金の必須チェック
 * @param {Object} obj - vmインスタンス
 * @param {Object} item - 中型表示品目
 */
function optionsCheck(obj, item) {
    if (obj.siteCodeInfo[0].PRICING_METHOD == 2 && item.unit > 0 && item.options.length > 0) {
        item.options.forEach(option => {
            if (item.selectedOptions[option.fee_kbn.code]['feeCat'] === null) {
                obj.setErrorFlg(true)
                item.selectedOptions[option.fee_kbn.code]['required'] = true
            } else {
                item.selectedOptions[option.fee_kbn.code]['required'] = false
            }
        })
    }
}

/**
 * 表示料金
 * @param {Object} obj - vmインスタンス
 * @param {Object} item - 中型表示品目
 */
function setTotalFee(obj, item) {
    // 料金区分が「回収料金」以外の金額
    const optionFee = item.options.reduce((acc, cur) => {
        if (item.selectedOptions[cur.fee_kbn.code]['feeCat'] === null) {
            acc += 0
        } else {
            const feeCat = cur.fee_cat.find(cat => cat.code === item.selectedOptions[cur.fee_kbn.code]['feeCat'])
            acc += feeCat.fee
        }
        return acc
    }, 0)

    item.totalFee = item.fee + optionFee
    item.totalFeeIncTax = item.fee_inc_tax + common.includingTax(optionFee, obj.salesTaxRate)
}

function showFeeUp(obj, item) {
    return obj.siteCodeInfo[0].PRICING_METHOD == 2 && (item.options.length === 0 || (item.options.length > 0 && item.unit === 0))
}

function showFeeDown(obj, item) {
    return obj.siteCodeInfo[0].PRICING_METHOD == 2 && item.options.length > 0 && item.unit > 0
}
function unitInput(item, event) {
    item.unit = Math.max(Number(event.target.value), 0)
    item.unitFlg = item.unit > 1
}
function setDefault(item) {
    item.unitFlg = true
    item.unit = 2
}

function getTotalUnits(obj){
    let total = 0;
    // 中型家電の台数を合計
    obj.items.forEach(item => {
        if (item.unit > 0) {
            total += item.unit;
        }
    });
    // 追加の家電台数を合計
    if (obj.addItem.unit > 0) {
        total += obj.addItem.unit;
    }
    return total;
}

function limitTotalUnits(obj, newVal){
    // 合計台数が0または箱数が合計台数より多い場合、箱数を合計台数に合わせる
    if(newVal === 0 || obj.mediumBox.medium_box_cnt > newVal){
        obj.mediumBox.medium_box_cnt = newVal;
    // デフォルト1箱
    }else if(obj.mediumBox.medium_box_cnt === 0){
        obj.mediumBox.medium_box_cnt = 1;
    }
}


export default {
    common,
    inputRetention,
    setUnit,
    submitMediumItems,
    pageBack,
    setTotalFee,
    showFeeUp,
    showFeeDown,
    unitInput,
    setDefault,
    getTotalUnits,
    limitTotalUnits
}
